/**
 * @fileoverview Slice Redux para gerenciamento do modal RoleManager.
 * Controla estado de abertura/fechamento do modal de gerenciamento de roles.
 * Implementa padrão Redux Toolkit com createSlice.
 * 
 * @module RoleManagerSlice
 * @requires @reduxjs/toolkit
 * @since 1.0.0
 * @version 1.0.0
 *
 * @see {@link ../../components/Role/RoleManager.jsx} - Componente que usa este slice
 * @see {@link ../store.js} - Store Redux que integra este reducer
 */

import { createSlice } from '@reduxjs/toolkit';

const roleManagerSlice = createSlice({
  name: 'roleManager',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de roles.
     * @function openRoleManager
     * @param {Object} state - Estado atual do slice
     * @returns {void}
     */
    openRoleManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de roles.
     * @function closeRoleManager
     * @param {Object} state - Estado atual do slice
     * @returns {void}
     */
    closeRoleManager: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openRoleManager, closeRoleManager } = roleManagerSlice.actions;
export default roleManagerSlice.reducer;